<template>
  <div class="message-container">
    <div v-if="items.length > 0" class="message-container__list">
      <div
        v-for="(item, index) in items"
        :key="'studentMessage' + index"
        class="message-container__list-item"
      >
        <em class="fa fa-info-circle orange-icon" />
        <span>{{ item }}</span>
      </div>
    </div>
    <div
      v-if="hasTapRequest && showTapRequestAlert"
      class="message-container__list mt-3"
    >
      <div class="row">
        <div class="col-sm-9">
          <p class="text">
            Este estudiante cuenta con una Solicitud de asistencia técnica para
            ubicación del estudiante
          </p>
          <strong class="question">
            ¿Desea ver el detalle de la solicitud?
          </strong>
        </div>
        <div class="col-sm-3 d-flex justify-content-center align-items-center">
          <button
            type="button"
            class="btn btn-success btn-message yes d-flex align-items-center justify-content-center"
            @click="goToDetail()"
          >
            Sí
          </button>
          <button
            type="button"
            class="btn btn-danger btn-message no d-flex align-items-center justify-content-center"
            @click="returnToDashboard()"
          >
            No
          </button>
        </div>
      </div>
    </div>
    <div v-if="items.length > 0 && !hasTapRequest" class="text-right mt-3">
      <action-button
        variant="outline-success"
        text="Continuar"
        i="fas fa-arrow-circle-right"
        @click="continueWithSetStudent"
      />
    </div>
  </div>
</template>

<script>
export const TapRequestStatus = {
  NEW: 1,
  SUBMITTED: 2,
};
import { createNamespacedHelpers } from 'vuex';
import { ActionButton } from '@/components/common';
import studentService from '@/services/student';

const { mapMutations } = createNamespacedHelpers('$_student');
export default {
  name: 'StudentMessage',
  components: {
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    hasTapRequest: {
      type: Boolean,
      default: () => false,
    },
    showTapRequestAlert: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      tapRequestStatus: null,
    };
  },
  computed: {
    navigateToViewRoute() {
      return this.$store.state.navigateToViewRoute;
    },
    studentSieId() {
      return this.$store.getters.SelectedStudent.studentId;
    },
  },
  methods: {
    ...mapMutations([
      'setClearStudentAlerts',
      'toggleSearchMenu',
      'setNavigationToViewDisplay',
      'clearSelectedStudent',
    ]),
    continueWithSetStudent() {
      this.setClearStudentAlerts();
      this.toggleSearchMenu(false); //Close Menu
      this.$store.commit('$_student/showStudentBox', true);
      studentService.sendReadAlert(this.studentSieId);

      if (this.navigateToViewRoute) {
        this.setNavigationToViewDisplay(true);
      }
    },
    returnToDashboard() {
      this.clearSelectedStudent();
      this.toggleSearchMenu(false);
    },
    goToDetail() {
      this.toggleSearchMenu(false);
      this.$router.push({ name: 'ubicationTechAssistance' });
    },
  },
};
</script>

<style scoped lang="scss">
.orange-icon {
  color: #ff7058;
}
.message-container {
  padding: 20px;
  &__list {
    background: #f2f2f2;
    padding: 20px;

    .text,
    .question {
      font: normal normal normal 16px/20px Lato;
      letter-spacing: 0px;
      color: #11291b;
    }
    .question {
      font-weight: bold;
    }
    .btn-message {
      width: 49px;
      height: 38px;
      color: white;
      &.yes {
        background-color: #2db782;
      }
      &.no {
        background-color: #d01c1c;
      }
    }
  }
  &__list-item {
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
    em {
      margin-top: 5px;
      margin-right: 10px;
    }
    span {
      flex: 1;
    }
  }
}
</style>
